export default __webpack_public_path__ + "static/media/no-coloured-learner.52de5304.svg";